import {
  messageRuleCodeMap,
  partnerCampaignTest,
  partnerFeaturePropertiesTarget,
} from '@/views/config/partner-refer/helper/constant';
import { isEmptyVal } from '@/utils';
import _ from 'lodash';

/// do not depend on store
export const checkPartnerForAbTest = (ruleList = []) => {
  const version = partnerCampaignTest.version;
  if (isEmptyVal(ruleList) || _.includes(ruleList, version)) {
    return true;
  }
};

export const getPartnerMessageWithSomePureRules = (messageList = [], defaultMsg = "") => {
  const item = _.find(messageList, (p) => {
    if (isEmptyVal(p?.messageRuleList)) {
      return true;
    }

    return _.every(p?.messageRuleList, (x) => {
      const { ruleCode, ruleValue } = x || {};

      if (ruleCode === messageRuleCodeMap.abTest) {
        const ruleList = partnerFeaturePropertiesTarget.getFormatedValue(ruleCode, ruleValue);
        return checkPartnerForAbTest(ruleList);
      }

      return true;
    });
  });

  return item?.messageBody ?? defaultMsg;
};
